import e from "../managers/braze-instance.js";
import ea from "./push-manager-factory.js";
export function unregisterPush(r, n) {
  if (e.rr()) return ea.aa().unsubscribe(r, n);
}
